module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Image8656.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-3",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "bold CharOverride-7"
  }, [_vm._v("HERMAN’S BROWN BUCKEYES")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter-subtitle",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "all-caps"
  }, [_vm._v("Amber Lanier Nagle")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I sat curled-up in a ball on the sofa watching television when Daddy strolled in and collapsed into the black vinyl cushions of his favorite recliner. He exhaled heavily with a breathy “Whooey,” at the end and set a glass of bourbon and Coke on a nearby coaster.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His manly aroma floated across the room, and I breathed it in—a mixture of deer blood, alcohol, sweat, and cigarette smoke—an earthy smell that, to this day, reminds me of Daddy. He had spent the majority of the weekend with his buddies at K&G Hunting Club just outside of Lizella, Georgia doing whatever he and the other men did out there.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What does he do at the hunting club?” I often asked my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, I don’t know,” Mom said. “Walk around, look for deer tracks, build deer hunting stands, pull trucks out of the mud, drink too much and gamble next to the campfire with the other men. Your father finds refuge in being outdoors.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My dad, Herman Franklin Lanier, worked two jobs to support our family of five. He supervised an air freight terminal at a local Air Force base and installed trailer hitches on vehicles at a business in Macon that he owned with my Uncle Edwin. But many weekends—especially when there was a hint of fall in the air—Daddy retreated to the woods to recharge his batteries.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I looked over at him that day. He wore a dirty camouflage shirt, a cap, tattered jeans, and an old pair of black sneakers with clots of dried mud hanging on the soles. Mom would be upset when the dirt fell onto her clean linoleum floor later that evening. He kneaded his neck for a few strokes and let out a heavy sigh before emptying the weekend’s souvenirs from his pockets—a few loose coins, a broken piece of chalky peppermint, a pocketknife, the tip of an arrowhead, and two buckeyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He tossed a buckeye over to me, and I caught it in my right hand. He grinned and said, “Keep it. It’ll bring you good luck.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Daddy was not a superstitious man, but during the years of my childhood, he handed me dozens of buckeyes he had retrieved from the forest’s floor, always followed by the promise of good fortune. I hoarded the shiny, brown nuggets for years keeping them in a jewelry box protected by a tiny, twirling ballerina, and I had a pretty lucky childhood, so I had no reason to doubt the mysterious power of buckeyes. I was a true-blue buckeye believer.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As a young adult, I stashed them everywhere—in the side panels of my pocketbooks, in the belly drawer of my desk, in the glove compartment of my car, and in the pockets of my coats and jackets. After a while, the buckeyes reminded me less and less of luck and fortune, and more and more of my father and his lifelong love of all things outdoors—hunting, fishing, sitting by a glowing campfire, and roaming the backwoods of Georgia on foot.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As I grew older, I grew away from my childhood passions and possessions, and like most people do, I grew away from my parents a bit, too. I eventually packed the dolls and toys that populated my childhood away neatly in boxes, and I stopped collecting buckeyes. They just weren’t a priority any more.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then in August of 1992, Daddy died. He was here one day, and the next day, he was simply "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("gone")]), _vm._v(". Mom, my siblings and I gathered to mourn and plan his funeral and burial, all the while wondering and guessing what he would have wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mom finally decided to bury Daddy in a pair of denim jeans and a flannel shirt. “That’s what he was most comfortable wearing,” she said, and Andy, Audrey, and I agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The four of us drove to the funeral home that evening to view Daddy’s body privately. I’ve never felt as broken as when I saw my father’s lifeless body lying in that casket. I was terrified that I would eventually forget what he looked like, so I scrutinized every detail of his face—every wrinkle and every scar—and burned his image to my memory. His graying hair was missing on top of his head, and his nose was large and bony—a replica of my own nose, but with a web of broken blood vessels that come with age.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The flannel shirt we had selected for him had a pocket on the left-hand side. “Herman always had to have a pocket on his shirts,” Mom remarked that night, standing at his side. “He had to have a place to put those damned cigarettes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But there were no cigarettes that night. The pocket was oddly empty, and that’s when I had the idea: to honor my father, I would place a buckeye in his shirt pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At home that night, I searched high and low for a nice, round buckeye to tuck in Daddy’s pocket prior to the funeral. I fumbled through the contents of the junk drawer in our kitchen—no buckeye. I fell on the floor of my closet and opened a dusty shoebox of miscellaneous trinkets—still, no buckeye. Coat pockets—empty. Car console—nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I called my mother and relayed my dilemma to her. She comforted me and told me not to worry about it, but my heart collapsed. In a lifetime of being surrounded by Daddy’s buckeyes, how could I not find even "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("one")]), _vm._v(" in the hiding places of my life? I felt ashamed—as if I had failed him in some way.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The following day, friends and family members congregated at the funeral home to pay their final respects. The experience was surreal. Daddy’s open casket rested at the front of the room illuminated by a dozen tiny spotlights and surrounded by elaborate flower arrangements and potted peace lilies. People mingled as if it were a cocktail party occasionally working their way over to my father’s figure. It was as if Daddy were sleeping in the middle of a social gathering.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mom’s best friend, Nita, approached me with a consoling smile, then hugged me tightly. She took my hand and dropped something into it. One of the smooth, mahogany nuggets so familiar to me—so dear to my heart—rested on the flat surface of my palm. I stared at the beautiful, unblemished buckeye as if it was a chunk of gold then glanced up at her face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Your mama told me that you were looking for one of these,” Nita said. “My daddy used to give them to me, too.” She blinked, and her eyes were instantly covered with a layer of tears that refused to fall. I thanked her and made my way through the crowd to my father’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I carefully placed the buckeye in his flannel pocket and let my hand rest upon the soft cloth above his still heart for a moment. I whispered, “Keep it. It’ll bring you good luck, Daddy,” and I felt a great peace wash over me.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Today, like my father was so long ago, I, too, am a collector and keeper of buckeyes. Indeed, they are keepsakes to me. They grace the nooks and crannies of my everyday life, and when I randomly discover one, I roll it around in my hands and imagine the luck rubbing onto my fingertips.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When I hold one in my hand and squeeze, I am ten years old again, and my father stands before me with pockets filled with treasures and secrets he so willingly shares with me. Perhaps that’s the true power of buckeyes—not the supposed luck associated with them, but the fact that these simple pieces from nature connect one generation to another. They connect me to my father—"), _c('span', {
    staticClass: "ital"
  }, [_vm._v("forever")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Amber Lanier Nagle is the curator of many keepsakes. She is freelance writer specializing in prescriptive nonfiction pieces. Her articles have appeared in ")]), _c('em', {
    staticClass: "italic CharOverride-7"
  }, [_vm._v("Grit")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(",")]), _c('em', {
    staticClass: "italic CharOverride-7"
  }, [_vm._v(" Mother Earth News")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(",")]), _c('em', {
    staticClass: "italic CharOverride-7"
  }, [_vm._v(" Georgia Magazine")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(",")]), _c('em', {
    staticClass: "italic CharOverride-7"
  }, [_vm._v(" Chatter")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(",")]), _c('em', {
    staticClass: "italic CharOverride-7"
  }, [_vm._v(" Get Out Chattanooga")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(",")]), _c('em', {
    staticClass: "italic CharOverride-7"
  }, [_vm._v(" Savannah Magazine")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(", and many others. She is the author of an eBook, ")]), _c('em', {
    staticClass: "italic CharOverride-7"
  }, [_vm._v("Southern Exposure: A Few Random, Rambling Retrospective Pieces of My Life")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(" and teaches memoir writing and freelancing workshops throughout Northwest Georgia for writers of all skill levels. Connect with Amber at ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("www.AmberNagle.com")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a38f100","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectKeepsake62.vue
// module id = 72
// module chunks = 0